<template>
  <div class="wrapper dev">
    <div class="breadcrumb">{{$t("main.nav[0].list[0].title")}} -<b>{{$t("main.des[0].list[14].title")}}</b></div>
    <div class="container" @mouseenter="on_enter" @mouseleave="on_leave">
      <swiper :options="swiperOption" class="gallery-main" v-if="imgList.length" ref="mySwiper">
        <swiper-slide v-for="item in imgList" :key="item">
          <img :src="item"/>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev swiper-btn" slot="button-prev"></div>
        <div class="swiper-button-next swiper-btn" slot="button-next"></div>
      </swiper>
      <div class="des">
        <happy-scroll color="rgba(0,0,0,0.5)" size="5" class="news-scroll" :resize="true" hide-horizontal>
          <!-- 内层盒子——内容区 -->
          <div class="con">
            <div class="title">{{$t("main.des[0].list[14].title")}}</div>
            <div class="text" v-html='$t("main.des[0].list[14].text")'></div>
          </div>
        </happy-scroll>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'doubleSwiper',
  data () {
    return {
      text: '$t("main.des[0].list[14].text")',
      imgList: [
        'static/images/main/estate/dev/hpdf-01.jpg',
        'static/images/main/estate/dev/hpdf-02.jpg',
        'static/images/main/estate/dev/hpdf-03.jpg',
        'static/images/main/estate/dev/hpdf-04.jpg',
        'static/images/main/estate/dev/hpdf-05.jpg',
        'static/images/main/estate/dev/hpdf-06.jpg'
      ],
      // notNextTick: true,
      swiperOption: {
        autoHeight: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        loop: true,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  mounted () {
    // console.log(this.imgList)
  },
  beforeMount () {
  },
  computed: {
    mySwiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    on_enter () {
      this.mySwiper.autoplay.stop()
    },
    on_leave () {
      this.mySwiper.autoplay.start()
    }
  },
  created () {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    font-size 15px
    line-height 26px
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
      b
        font-weight normal
        margin-left 10px
    .gallery-main:hover
      .swiper-btn,.swiper-pagination
        opacity 1
    .gallery-main
      .swiper-pagination
        opacity 0
        transition opacity 1s
      .swiper-btn
        background rgba(0,0,0,0.3)
        background-repeat no-repeat
        background-size cover
        border-radius 3px
        padding 4px 4px
        opacity 0
        transition opacity 1s
      .swiper-button-prev
        background-image url("~assets/common/width-64-left.png")
        background-position center left
      .swiper-button-next
        background-image url("~assets/common/width-64-right.png")
        background-position center right
    .des
      height 350px
      overflow hidden
      position relative
      left -20px
      .title
        font-size 20px
        font-weight bold
        line-height 32px
      .text
        padding-bottom 30px
      .des
        b
          font-weight bold
      .news-scroll
        right -40px
      .con
        padding-right 40px
</style>



// WEBPACK FOOTER //
// src/pages/main/components/hpDF.vue